import LoadCardDetail from './load-card-detail';

export default LoadCardDetail;
